module.exports = __webpack_public_path__ + "media/images/flags/4x3/pak-c6b49a9f5bb9af1e10771ff7b05836a7.svg";